import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const bonuses = [{
  tag: '🎁 Bonus n° 1',
  emoji: '🎥',
  title: 'PACK ARCADE EN CARTON',
  text: 'Une amusante collection de vidéos qui montre étape par étape comment construire des jeux interactifs comme une mini table de spaceball, des roues de la fortune personnalisées et des bornes d’arcade avec du simple carton et beaucoup d’imagination.',
  img: 'https://cdn.magicpatterns.com/uploads/kX7zgPdQHdv9BM33ASEWE4/ChatGPT_Image_3_oct_2026,_03_36_04_p.m..png',
  price: '$25,00',
  tone: 'bg-sky-light',
  tagTone: 'bg-sky/20 text-sky'
}, {
  tag: '🎁 Bonus n° 2',
  emoji: '✂️',
  title: 'LE GUIDE DES BRICOLAGES EN PAPIER EN 5 MINUTES',
  text: 'Votre manuel de référence pour des bricolages rapides et propres en papier et en carton. Parfait pour les après-midi où vous n’avez pas de matériel spécial mais voulez une activité simple pour les éloigner des écrans.',
  img: 'https://cdn.magicpatterns.com/uploads/ox4zMfSaqmdC46AQPS3naR/Gemini_Generated_Image_it96giit96giit96.jpg',
  price: '$19,00',
  tone: 'bg-sunshine-light',
  tagTone: 'bg-sunshine/30 text-ink'
}, {
  tag: '🎁 Bonus n° 3',
  emoji: '🌈',
  title: 'PETITS CRÉATEURS : SLIME ET JEUX SENSORIELS',
  text: 'Un guide spécialisé rempli de recettes faciles de slime maison, de pâte à modeler et de textures sensorielles. Idéal pour occuper joyeusement les plus petits pendant qu’ils créent de leurs propres mains.',
  img: 'https://cdn.magicpatterns.com/uploads/gcB21rUC8nAv8ifHwxG25W/Gemini_Generated_Image_xwhsejxwhsejxwhs.jpg',
  price: '$19,00',
  tone: 'bg-coral-light',
  tagTone: 'bg-coral/20 text-coral'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-23" data-mp="noq7t0gefx1u">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-24" data-mp="iqyec203w2vj">
        <SectionHeading eyebrow="🎁 Bonus exclusifs" title={<>Commandez aujourd’hui et recevez ces 3 bonus gratuits</>} subtitle="Obtenez MakerLab aujourd’hui et débloquez aussi ces 3 bonus exclusifs — à vous pour toujours, sans frais supplémentaires." data-id="element-25" data-mp="iqevmj2mtagg" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-26" data-mp="3lk4d08acgrwc">
          {bonuses.map((b, i) => <motion.article key={b.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`flex flex-col overflow-hidden rounded-3xl border border-ink/10 ${b.tone}`} data-id="element-27" data-mp="3qhedqk36opzh" data-mpi={i}>
              <div className="aspect-square w-full overflow-hidden border-b border-ink/10" data-id="element-28" data-mp="2f2qzvrndy3dr">
                <img src={b.img} alt={b.title} className="h-full w-full object-cover" data-id="element-29" data-mp="27kjc2wtiu9ko" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-30" data-mp="1xltul55jer4y">
                <div className="mb-3 flex items-center justify-between" data-id="element-31" data-mp="1xk8yhb3kr04z">
                  <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${b.tagTone}`} data-id="element-32" data-mp="1tl0547cg549y">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-33" data-mp="1on8c1a02fc46" />
                    {b.tag}
                  </span>
                  <span className="flex items-center gap-1.5 text-sm" data-id="element-34" data-mp="1ev2n69541at7">
                    <span className="text-ink/40 line-through" data-id="element-35" data-mp="1eszoz1tt0bde">{b.price}</span>
                    <span className="font-bold text-emerald-600" data-id="element-36" data-mp="19y2io2nwsg47">GRATUIT</span>
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-37" data-mp="15wgwtrtecrhv">
                  {b.emoji} {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-38" data-mp="30yvi9ik14gix">
                  {b.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}